exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LoginCard__form{margin-top:var(--vds-space-xl);width:100%;max-width:18rem}@media (max-width:500px){.LoginCard__form{margin-top:var(--vds-space-md);max-width:none}}p.LoginCard__errorMessage{margin-top:var(--vds-space-md)}", ""]);

// exports
exports.locals = {
	"form": "LoginCard__form",
	"errorMessage": "LoginCard__errorMessage"
};